import { Appointment } from '@2meters/types'
import { db } from 'api/Firebase/firebase-init'
import { collectionGroup, onSnapshot, query, where } from 'firebase/firestore'
import { create } from 'zustand'

interface TicketsStore {
  userId: string | undefined
  isLoadingTickets: boolean
  tickets: Appointment[]
  subscribe: (userId: string) => void
  unsubscribe: () => void
}

export const useTickets = create<TicketsStore>((set, get) => ({
  userId: undefined,
  isLoadingTickets: true,
  tickets: [],

  subscribe: userId => {
    if (get().userId === userId) return
    set({ isLoadingTickets: true, userId })
    if (!userId) {
      set({ tickets: [], isLoadingTickets: false })
      return
    }

    const ref = query(collectionGroup(db, `tickets`), where('userId', '==', userId))

    const unsubscribeFromFirestore = onSnapshot(
      ref,
      snap => {
        const tickets = snap.docs.map(doc => doc.data() as Appointment)
        set({ tickets, isLoadingTickets: false })
      },
      (error: any) => {
        console.error('useTickets onSnapshot error', error)
        set({ tickets: [], isLoadingTickets: false })
      }
    )

    set({
      unsubscribe: () => {
        unsubscribeFromFirestore()
        set({ userId: undefined })
      },
    })
  },

  unsubscribe: () => {},
}))
